import { Controller } from "@hotwired/stimulus"

// Una riga Fonte di pages/RegistroFonti.js: la matita apre e chiude la modifica (setModifica((m) => !m)), «Collega» del
// catalogo resta disattivato finché non si sceglie un bando (disabled={busy || !scelto}); mentre un'azione della riga è
// in corso (busy) tutti i suoi pulsanti sono disattivati e «Controllata oggi» mostra la rotella.
export default class extends Controller {
  static targets = ["modifica", "scelto", "collega", "rotella"]

  apri() {
    const aperta = this.modificaTargets.some((el) => !el.hidden)
    this.modificaTargets.forEach((el) => { el.hidden = aperta })
  }

  scelto() {
    if (this.hasCollegaTarget) this.collegaTarget.disabled = !this.sceltoTarget.value
  }

  inizia() {
    this.disattivati = [...this.element.querySelectorAll("button:not([disabled])")]
    this.disattivati.forEach((b) => { b.disabled = true })
    this.rotellaTargets.forEach((el) => { el.hidden = false })
  }

  fine() {
    ;(this.disattivati || []).forEach((b) => { if (b.isConnected) b.disabled = false })
    this.disattivati = []
    this.rotellaTargets.forEach((el) => { el.hidden = true })
    this.scelto()
  }
}
